import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Activity, Boxes, ClipboardList, Package, ArrowRightLeft } from "lucide-react";

const actionMeta = {
  urun_ekle: { icon: Package, color: "text-[#16A34A]", label: "Ürün Eklendi" },
  urun_duzenle: { icon: Package, color: "text-secondary", label: "Ürün Düzenlendi" },
  urun_sil: { icon: Package, color: "text-destructive", label: "Ürün Silindi" },
  stok_giris: { icon: Boxes, color: "text-[#16A34A]", label: "Stok Girişi" },
  stok_cikis: { icon: Boxes, color: "text-destructive", label: "Stok Çıkışı" },
  sayim: { icon: ArrowRightLeft, color: "text-secondary", label: "Sayım" },
  siparis_talep: { icon: ClipboardList, color: "text-primary", label: "Sipariş Talebi" },
};

export default function ActivityPopup() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/activities/new").then((r) => {
      if (r.data.length > 0) { setItems(r.data); setOpen(true); }
    }).catch(() => {});
  }, []);

  const time = (iso) => { try { return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg" data-testid="activity-popup">
        <DialogHeader>
          <DialogTitle className="font-head text-2xl flex items-center gap-2">
            <Activity className="h-6 w-6 text-primary" /> Son Girişinizden Bu Yana
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground -mt-2">Yokluğunuzda {items.length} işlem gerçekleşti.</p>
        <div className="max-h-[50vh] overflow-y-auto space-y-2">
          {items.map((a) => {
            const m = actionMeta[a.action] || { icon: Activity, color: "", label: a.action };
            const Icon = m.icon;
            return (
              <div key={a.id} className="flex items-start gap-3 border rounded-lg p-3">
                <div className={`h-9 w-9 rounded-lg bg-muted flex items-center justify-center shrink-0 ${m.color}`}><Icon className="h-4 w-4" /></div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold">{m.label} <span className="text-muted-foreground font-normal">· {a.user_name}</span></div>
                  <div className="text-xs text-muted-foreground">{a.description}</div>
                </div>
                <div className="text-[11px] text-muted-foreground whitespace-nowrap">{time(a.created_at)}</div>
              </div>
            );
          })}
        </div>
        <Button onClick={() => setOpen(false)} data-testid="activity-popup-close">Anladım</Button>
      </DialogContent>
    </Dialog>
  );
}
